import { useMemo } from 'react';

import type { ShareChannel, UseShareActionsOptions } from '#src/app/shared/hooks/share';

import { useGetShareContent } from './content';
import { useOnShareSuccess } from './success';
import { useGetShareTrackingData } from './tracking';

export function useShareOptions(): UseShareActionsOptions<ShareChannel> {
	const getContent = useGetShareContent();
	const getTrackingData = useGetShareTrackingData();
	const onSuccess = useOnShareSuccess();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getContent,
			getTrackingData,
			onSuccess,
		}),
		[getContent, getTrackingData, onSuccess],
	);
}
